import { z } from 'zod'

export const postTypeSchema = z.enum([
  'text',
  'image',
  'post',
  'video',
  'live',
  'story',
  'blog',
  'other',
  'short',
  'ad_authorization', // 廣告授權
  'material_authorization', // 素材授權
])

export type PostType = z.infer<typeof postTypeSchema>
